import { AlertFactory, AlertState } from 'alerts/Alert'
import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'
import { task } from 'mobx-task'

/**
 * View Model for Notify Pros of Open Job Dialog.
 */
export class NotifyProsOfOpenJobDialogViewModel extends ModalViewModel {
  constructor(
    private readonly job: Job,
    private readonly jobStore: JobStore,
    private readonly newAlert: AlertFactory,
  ) {
    super()
  }

  /**
   * Notifies all pros that the job is available for pickup.
   */
  notifyProsOfOpenJob = task.resolved(async () => {
    if (!this.job.canNotifyPros) {
      return
    }

    await this.jobStore
      .notifyProsOfOpenJob(this.job)
      .then(this.close)
      .then(() =>
        this.newAlert()
          .withState(AlertState.Success)
          .saying('All available pros were successfully notified.')
          .autoDismiss()
          .show(),
      )
  })
}
